export const benefitsAccordionTableContent = [
  {
    title: 'Breakdown coverage',
    description: "We'll protect your product after the manufacturer's warranty ends.",
  },
  {
    title: 'Accidental damage coverage (includes accessories)',
    description: "Coverage for life's mishaps.",
  },
  {
    title: 'Unlimited repairs ',
    description: 'Get unlimited repairs by authorized technicians, using factory-certified parts.',
    additionalContent: 'Only for breakdowns',
  },
  {
    title: "A replacement if it can't be fixed",
    description: "If we can't fix it, we'll replace it (includes delivery of your new product).",
    additionalContent: 'Only for breakdowns',
  },
  {
    title: 'No hidden costs',
    description: 'Zero deductibles on parts and labor.',
    additionalContent: 'Only for breakdowns',
  },
];
